import * as React from "react";

import { cn } from "@/lib/utils";

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "aero:border-input aero:placeholder:text-muted-foreground aero:focus-visible:border-ring aero:focus-visible:ring-ring/50 aero:aria-invalid:ring-destructive/20 aero:dark:aria-invalid:ring-destructive/40 aero:aria-invalid:border-destructive aero:dark:bg-input/30 aero:flex aero:field-sizing-content aero:min-h-16 aero:w-full aero:!rounded-md aero:border aero:bg-transparent aero:px-3 aero:py-2 aero:text-base aero:shadow-xs aero:transition-[color,box-shadow] aero:outline-none aero:focus-visible:ring-[3px] aero:disabled:cursor-not-allowed aero:disabled:opacity-50 aero:md:text-sm",
        className
      )}
      {...props}
    />
  );
}

export { Textarea };
